import { useState, useEffect } from "react";
import baseurl from "../../baseurl";
const RegisteredNonStudents = (props) => {
  const [registeredNonStudents, setregisteredNonStudents] = useState([]);
  const [fetching, setfetching] = useState(false);
  const [docs, setdocs] = useState({});
  useEffect(() => {
    setregisteredNonStudents(props.registeredNonStudents);
  }, [props]);

  const deleteNonStudent = (attendee) => {
    fetch(`${baseurl}/non-student`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        authorization: "Bearer " + props.token,
      },
      body: JSON.stringify({
        email: attendee.email,
        nonStudentId: attendee.nonStudentId,
        collegeId: attendee.collegeId,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status === 200) {
          refreshAttendeelist();
        }
      });
  };
  const refreshAttendeelist = () => {
    fetch(`${baseurl}/non-student/all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        data.status === 200
          ? setregisteredNonStudents(data.data)
          : setregisteredNonStudents([]);
      });
  };
  const getDocument = (attendee) => {
    setfetching(true);
    fetch(`${baseurl}/non-student/docs`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
        nonStudentId: attendee.nonStudentId,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status === 200) {
          setdocs(data.data);
          setfetching(false);
        }
      });
  };
  const reInstateEdit = (attendee) => {
    fetch(`${baseurl}/non-student/editaccess`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        authorization: "Bearer " + props.token,
      },
      body: JSON.stringify({
        nonStudentId: attendee.nonStudentId,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status === 200) {
          refreshAttendeelist();
        }
      });
  };
  const clearDocument = () => {
    setdocs({});
    setfetching(false);
  };

  return (
    <div className="row">
      <div className="col-12 mt-5 mb-5">
        <h2>Registered Non Students - {registeredNonStudents.length}</h2>
        <h4>
          <strong>
            The registrations have ended and all details are frozen.
          </strong>
        </h4>
        {registeredNonStudents.length > 0 ? (
          <>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Sl. No.</th>
                  <th scope="col">Name</th>
                  <th scope="col">Email ID</th>
                  <th scope="col">Role</th>
                  <th scope="col">Phone Number</th>
                  <th scope="col">Gender</th>
                  <th scope="col">Show Details</th>
                  <th scope="col">Show Documents</th>
                  <th scope="col">Edit access</th>
                  <th scope="col">Delete Member</th>
                </tr>
              </thead>
              {registeredNonStudents.map((attendee, index) => {
                return (
                  <>
                    <tbody>
                      <tr>
                        <th scope="row">{index + 1}</th>
                        <td className="text-start">
                          <strong>{attendee.name}</strong>
                        </td>
                        <td className="text-start">
                          <strong>{attendee.email}</strong>
                        </td>
                        <td className="text-start">
                          {attendee.role ? attendee.role.toUpperCase() : "-"}
                        </td>
                        <td className="text-start">
                          {attendee.phoneNo ? attendee.phoneNo : "-"}
                        </td>
                        <td className="text-start">
                          {attendee.gender
                            ? attendee.gender.toUpperCase()
                            : "-"}
                        </td>
                        <td className="text-start">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            data-bs-toggle="modal"
                            data-bs-target={"#" + attendee.nonStudentId}
                          >
                            Show Details
                          </button>
                        </td>
                        <td className="text-start">
                          <button
                            type="button"
                            className="btn btn-outline-success "
                            data-bs-toggle="modal"
                            data-bs-target={"#doc" + attendee.nonStudentId}
                            onClick={() => {
                              getDocument(attendee);
                            }}
                          >
                            Show Documents
                          </button>
                        </td>
                        <td className="text-start">
                          <button
                            type="button"
                            className="btn btn-outline-warning "
                            onClick={(e) => {
                              reInstateEdit(attendee);
                            }}
                            disabled
                          >
                            Reinstate edit access
                          </button>
                        </td>
                        <td className="text-start">
                          <button
                            type="button"
                            className="btn btn-outline-danger "
                            data-bs-toggle="modal"
                            data-bs-target={"#delete" + attendee.nonStudentId}
                            disabled
                          >
                            Delete {attendee.name}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    {/* Delete Non Student */}
                    <div
                      className="modal fade"
                      id={"delete" + attendee.nonStudentId}
                      tabIndex="-1"
                      aria-labelledby={"delete" + attendee.nonStudentId}
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content bg-white text-start">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Delete {attendee.name}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <span>
                              <strong>Name : </strong>
                              {attendee.name}
                            </span>
                            <br />
                            <span>
                              <strong>Email : </strong>
                              {attendee.email}
                            </span>
                            <br />
                            <span>
                              <strong>Phone No. : </strong>
                              {attendee.phoneNo}
                            </span>
                            <br />
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-warning mt-2"
                              data-bs-dismiss="modal"
                              onClick={(e) => deleteNonStudent(attendee)}
                            >
                              Delete {attendee.name}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Show Non Student Docs */}
                    <div
                      className="modal fade"
                      id={"doc" + attendee.nonStudentId}
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                      tabIndex="-1"
                      aria-labelledby="staticBackdropLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg">
                        <div className="modal-content bg-white text-start">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="staticBackdropLabel"
                            >
                              Documents for {attendee.name}
                            </h5>

                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              onClick={(e) => {
                                clearDocument();
                              }}
                            ></button>
                          </div>
                          {fetching ? (
                            <div className="modal-body">
                              <small>
                                Note:- It may take upto 4 sec for image to load.
                              </small>
                              <h3>Loading...</h3>
                            </div>
                          ) : (
                            <div className="modal-body">
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <span>Photo</span>
                                  <br />
                                  {docs.photo ? (
                                    <img
                                      src={docs.photo}
                                      alt="photo"
                                      className="doc-img mt-2"
                                    />
                                  ) : (
                                    <span>Not Provided</span>
                                  )}
                                  <br />
                                </div>
                                <div className="col-md-6 col-12">
                                  <span>Aadhar</span>
                                  <br />
                                  {docs.aadhar ? (
                                    <img
                                      src={docs.aadhar}
                                      alt="aadhar"
                                      className="doc-img mt-2"
                                    />
                                  ) : (
                                    <span>Not Provided</span>
                                  )}
                                  <br />
                                </div>
                                <div className="col-md-6 col-12">
                                  <span>Signature</span>
                                  <br />
                                  {docs.signature ? (
                                    <img
                                      src={docs.signature}
                                      alt="signature"
                                      className="doc-img mt-2"
                                    />
                                  ) : (
                                    <span>Not Provided</span>
                                  )}
                                  <br />
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                              onClick={(e) => {
                                clearDocument();
                              }}
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={(e) => {
                                getDocument(attendee);
                              }}
                            >
                              Refresh Data
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Show Non Student Details */}
                    <div
                      className="modal fade"
                      id={attendee.nonStudentId}
                      tabindex="-1"
                      aria-labelledby={attendee.nonStudentId}
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg">
                        <div className="modal-content bg-white text-start">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              <strong>{attendee.name}</strong> |{" "}
                              <strong>{attendee.email}</strong>
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <span>
                              <strong>Name : </strong>
                              {attendee.name}
                            </span>
                            <br />
                            <span>
                              <strong>Email : </strong>
                              {attendee.email}
                            </span>
                            <br />
                            <span>
                              <strong>Phone No. : </strong>
                              {attendee.phoneNo}
                            </span>
                            <br />
                            <span>
                              <strong>Age. : </strong>
                              {attendee.age}
                            </span>
                            <br />
                            <span>
                              <strong>Date of Birth. : </strong>
                              {attendee.dob}
                            </span>
                            <br />
                            <hr />
                            <span>
                              <strong>Profile Registered on : </strong>
                              {attendee.createdAt}
                            </span>
                            <br />
                            <span>
                              <strong>Last Updated on : </strong>
                              {attendee.updatedAt}
                            </span>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </table>
          </>
        ) : (
          <h5>None of the attendees have accepted the invitation yet.</h5>
        )}
      </div>
    </div>
  );
};
export default RegisteredNonStudents;
